import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { UserUrl } from '../../../shared/urls/user.url';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { CentreUrl } from '../../../shared/urls/centre.url';
import { PriceUrl } from '../../../shared/urls/price.url';
import { Utility } from '../../../common/utility';
@Injectable()
export class ManageCentreService {
    constructor(public baseService: BaseService) {
    }
    getVATCharge() {
        const url = MasterDataUrl.GET_VAT_CHARGE;
        return this.baseService.getData(url);
    }
    getCentreList(param) {
        const url = CentreUrl.GET_CENTRE;
        return this.baseService.getData(url, param);
    }

    getCountryHasCentre() {
        const url = CentreUrl.GET_COUNTRIES_HAS_CENTRE;
        return this.baseService.getData(url);
    }

    getUserCountryList() {
        const url = UserUrl.GET_USER_COUNTRY;
        return this.baseService.getData(url);
    }

    getCentreGroupList() {
        const url = CentreUrl.GET_CENTRE_GROUPS;
        return this.baseService.getData(url);
    }

    getCentreDetail(id) {
        const url = CentreUrl.GET_CENTRE + `/${id}`;
        return this.baseService.getData(url);
    }

    addCentre(formData: FormData) {
        const url = CentreUrl.GET_CENTRE;
        return this.baseService.upload(url, formData);
    }

    editCentre(id: string, formData: FormData) {
        const url = CentreUrl.GET_CENTRE + `/${id}`;
        return this.baseService.upload(url, formData);
    }

    getCurrencyList() {
        const url = PriceUrl.GET_CURRENCIES;
        return this.baseService.getData(url);
    }

    getCentreByCurrency(id) {
        const url = CentreUrl.GET_CENTRE_BY_CURRENCY + `${id}`;
        return this.baseService.getData(url);
    }

    getTimeZoneList() {
        const url = CentreUrl.GET_ALL_TIME_ZONE;
        return this.baseService.getData(url);
    }

    getCentreLogo(centreId) {
        const url = Utility.stringFormat(CentreUrl.GET_CENTRE_LOGO, [centreId]);
        return this.baseService.getData(url);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-centre/manage-centre.service.ts